import * as React from "react";

type Props = {
  color?: string;
  onPress?: () => void;
  size?: number | string;
  style?: React.CSSProperties;
};

export function AzureIcon({ size = '40px', color = '#000000', style }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
      style={{ ...style }}
    >
      <path
        fill={color}
        d="M15 3.622v8.512L11.5 15l-5.425-1.975v1.958L3.004 10.97l8.951.7V4.005zm-2.984.428L6.994 1v2.001L2.382 4.356 1 6.13v4.029l1.978.873V5.869l9.038-1.818z"
      />
    </svg>
  )
}
